import { AdditionalText, Label } from 'aos-ds'
import { twMerge } from 'aos-ui-universal'
import React, { ReactNode } from 'react'

interface TaskFormFieldProps {
    label?: string
    required?: boolean
    error?: string
    seleniumLocation?: string
    className?: string
    children: ReactNode
}

export const TaskFormField = ({
    label,
    required,
    error,
    seleniumLocation,
    className,
    children,
}: TaskFormFieldProps) => (
    <div
        className={twMerge('gap-xs flex flex-col', className)}
        data-test-id={seleniumLocation ? `labeled-${seleniumLocation}` : undefined}
    >
        {label ? <Label required={required}>{label}</Label> : null}
        {children}
        {error ? (
            <AdditionalText variant='error' className='w-full'>
                {error}
            </AdditionalText>
        ) : null}
    </div>
)
